module.exports = __webpack_public_path__ + "img/icon-document.5ba2891a.svg";